var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-container",class:{ 'required-fail': _vm.requiredFail }},[_c('input',{class:{
      'with-label-button': _vm.automaticLabel
    },attrs:{"type":"text","disabled":_vm.disabled,"placeholder":_vm.placeholder,"id":_vm.fieldId},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.updateValue($event.target.value)},"keypress":function($event){_vm.restrictSpecialCharacters
        ? _vm.nameKeydown($event)
        : _vm.$emit('check-alphanumeric', $event)}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b9f9ff6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_Atoms/InputTypes/InputTypeText.vue
// module id = null
// module chunks = 